import React from 'react';
import { enums } from '~/util';
import { ServicesContext } from '~/services';
import { ExternalAccountInfo } from './ExternalAccountInfo';

interface UserIntegrationsProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
    editable: boolean;
}
export function UserIntegrations({ user, setServerError, editable }: UserIntegrationsProps) {
    const services = React.useContext(ServicesContext);
    const coreAppAccount = user?.user_external_accounts?.find(
        (x) => enums(['user', 'external_account_types', x.type]) === 'Core App'
    );
    const ohidAccount = user?.user_external_accounts?.find(
        (x) => enums(['user', 'external_account_types', x.type]) === 'One Healthcare ID'
    );

    return (
        <div className="card mb-2">
            <div className="card-header">Integrations</div>
            <div className="card-body">
                <ExternalAccountInfo
                    user={user}
                    accountName="LeadingReach"
                    externalAccount={coreAppAccount}
                    editable={editable}
                    setServerError={setServerError}
                />
                {services.user.hasFeatureToggle('one_healthcare_id') && (
                    <ExternalAccountInfo
                        user={user}
                        accountName="One Healthcare ID"
                        externalAccount={ohidAccount}
                        editable={editable}
                        setServerError={setServerError}
                    />
                )}
            </div>
        </div>
    );
}
